export default {
  // 'this' - $store
  byActionType: {
    // score (event) {
    //   const { extra, GamePeriod } = event
    //
    //   this.setIngameProperty({
    //     property: 'score',
    //     value: {
    //       home: extra['points-1'],
    //       away: extra['points-2']
    //     }
    //   })
    // }
  },
  // 'this' - $store
  byEventType: {
    'FINISH_GAME_PREMATURELY' ({ eventInfo: { title } }) {
      this.setPrematurelyGameFinish(title)
    }
    // 'SET' (event) {
    //   this.setIngameProperty({
    //     property: 'sets',
    //     value: {
    //       home: event.ScoreHome,
    //       away: event.ScoreAway
    //     }
    //   })
    // },
    // 'ADJUST_SETS' (event) {
    //   const { EventCode, extra, TeamNumber, Playtime, Timestamp } = event
    //
    //   this.setIngameProperty({
    //     property: 'sets',
    //     value: {
    //       home: event.ScoreHome,
    //       away: event.ScoreAway
    //     }
    //   })
    // }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    // 'POINT' (event) {
    //   console.log(this)
    //
    //   return 'GOOOOOOOOAAALL'
    // }
    'ADJUST_POINTS' (event) {
      return this.$t('trader.adjust.points.title')
    },
    /**
     * @return {string}
     */
    'CANCEL' (event, relatedEvent) {
      const { homeTeamTitle, awayTeamTitle } = this
      const { eventInfo } = event
      const { title } = eventInfo
      const { EventCode, extra, TeamNumber } = relatedEvent
      const { team } = extra
      const notPointEvents = ['TIMEOUT', 'BALL_IN_GAME', 'FINISH_PERIOD']

      if (notPointEvents.includes(EventCode)) {
        return `${title}: ${this.getEventTitle(relatedEvent)}`
      }

      if (EventCode === 'POINT') {
        return `
          ${title}: 
          ${relatedEvent.eventInfo.title}, 
          ${extra[`points-${team}`]}, 
          ${TeamNumber === 1 ? homeTeamTitle : awayTeamTitle}
        `
      }

      return `${title}: ${this.getEventTitle(relatedEvent)}`
    }
  }
}
